import React from "react";
import { ChatContainer } from "../../../../ui-kit/ChatMessage/ChatMessage";
import { Typography } from "../../../../ui-kit/Typography";
import { useWebTranslation } from "../../../../translations";
import { StepProps } from "../types";
import { useAllValidAnimals } from "components/Signup/store/selectors/animals";
import FlowButtons from "components/Signup/components/FlowButtons/FlowButtons";
import { AnimalSummary } from "components/Signup/components/AnimalSummary";
import Gutter from "ui-kit/Gutter";
import ErrorMessage from "components/ErrorMessage/ErrorMessage";
import { formatErrorMessage } from "utils/validation";
import { useError } from "components/Signup/store/selectors/metadata";

const Summary = ({ next, transitioning, previous, isValid }: StepProps) => {
  const { t } = useWebTranslation();

  const animals = useAllValidAnimals();
  const error = useError();

  return (
    <>
      <ChatContainer leaving={transitioning}>
        <div>
          <div style={{ display: "flex", gap: 16, flexDirection: "column" }}>
            <Typography variant="h2" align="center">
              {t("signup.summary.title")}
            </Typography>
            <Gutter size={2} />
            {[...animals].reverse().map((animal, index) => {
              return (
                <AnimalSummary
                  key={animal.id}
                  animal={animal}
                  isOpen={index === 0}
                />
              );
            })}
          </div>
        </div>
        {!!error && (
          <ErrorMessage>
            <Typography color="error">{formatErrorMessage(error)}</Typography>
          </ErrorMessage>
        )}
        <FlowButtons
          inProgress={transitioning}
          next={next}
          disabled={!isValid}
          previous={previous}
          backButton={false}
        />
      </ChatContainer>
    </>
  );
};

export default Summary;
